// extracted by mini-css-extract-plugin
export default {"chair":"styles_chair__LLMfy","glitch":"styles_glitch__B4lKw","enterLink":"styles_enterLink__ocAMf","tooltip":"styles_tooltip__Ea5I0"};